<ion-content>
  <div class="bg-bg-surface-default flex h-full flex-col overflow-hidden">
    <app-header />
    <div class="bg-bg-surface-low grow overflow-hidden">
      <div class="mx-auto h-full w-full max-w-[1440px] overflow-hidden">
        <div class="h-full space-y-12 overflow-auto px-4 py-12">
          <div class="mx-auto space-y-1">
            <h1 class="text-text-default text-center text-lg font-bold">
              {{ karyawan ? "Edit" : "Tambah" }} Karyawan
            </h1>
            <p class="text-text-subtler text-center text-sm">
              Ikuti langkah langkah {{ karyawan ? "pembaharuan" : "penambahan" }} karyawan
            </p>
          </div>
          <div class="flex gap-6">
            <div class="relative shrink-0">
              <div class="sticky top-0">
                <div class="border-line-default absolute top-4 bottom-4 left-8 border-l"></div>
                <div class="relative z-0">
                  @for (step of steps; track $index) {
                    <div
                      class="group flex items-center gap-3 p-4"
                      [ngClass]="{
                        active: step.value === currentStep,
                        pass: step.value < currentStep,
                      }">
                      <div
                        class="group-[.active]:bg-bg-tint-brand group-[.pass]:bg-bg-solid-brand bg-bg-surface-default flex h-8 w-8 items-center justify-center rounded-full">
                        <p
                          class="text-text-subtlest group-[.active]:text-text-brand text-sm font-semibold group-[.pass]:text-white">
                          {{ step.value }}
                        </p>
                      </div>
                      <div>
                        <p class="text-text-default text-sm font-medium">{{ step.label }}</p>
                        <p class="text-text-subtle text-xs">
                          @if (step.value < currentStep) {
                            Selesai
                          } @else {
                            Mengisi
                          }
                        </p>
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>
          <div class="w-full px-4">
              @switch (currentStep) {
                @case (1) {
                  <step-1
                    [form]="form.controls.profile"
                    [formError]="formError.profile"
                    (addBank)="addBankField()"
                    (removeBank)="removeBankField($event)"
                    (addKontakDarurat)="addKontakDaruratField()"
                    (removeKontakDarurat)="removeKontakDaruratField($event)"
                    (next)="currentStep = 2" />
                }
                @case (2) {
                  <step-2
                    [form]="form.controls.tanggungan"
                    [formError]="formError.tanggungan"
                    (back)="currentStep = 1"
                    (next)="currentStep = 3" />
                }
                @case (3) {
                  <step-3
                    [isEdit]="!!karyawan"
                    [form]="form.controls.contact"
                    [formError]="formError.contact"
                    (back)="currentStep = 2"
                    (next)="currentStep = 4" />
                }
                @case (4) {
                  <step-4
                    [isEdit]="!!karyawan"
                    [form]="form.controls.position"
                    [formError]="formError.position"
                    (back)="currentStep = 3"
                    (next)="currentStep = 5" />
                }
                @case (5) {
                  <step-5
                    [form]="form.controls.family"
                    [formError]="formError.family"
                    (add)="addFamilyField()"
                    (remove)="removeFamilyField($event)"
                    (back)="currentStep = 4"
                    (next)="submit()" />
                }
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ion-content>

<app-dialog-confirm
  [(visible)]="confirmLeaveVisible"
  title="Yakin keluar?"
  description="Jika ada data yang belum di simpan, maka data tersebut tidak akan disimpan"
  confirmText="Keluar"
  cancelText="Kembali"
  (submit)="confirmLeave()"
  (cancel)="hideConfirmLeave()" />
